//Blog
// Blog Box List 

export const blogBoxShadowList = [
    { id: 1, icon: 'user', text: 'Mark Jecno' },
    { id: 2, icon: 'thumbs-up', text: '02 Hits' },
    { id: 3, icon: 'comments', text: '598 Comments' },
]

export const blogBoxListData = [
    { id: 1, src: '2.jpg', date: '02', hits: '0 Hits' },
    { id: 2, src: '3.jpg', date: '03', hits: '02 Hits' },
];

//Blog Box Grid
export const blogBoxGridData = [
    {
        id: 1,
        image: "5.jpg",
    },
    {
        id: 2,
        image: "6.jpg",
    },
    {
        id: 3,
        image: "5.jpg",
    },
    {
        id: 4,
        image: "6.jpg",
    },
];

// Blog single
export const blogSingleData = [
    { id: 1, src: 'comment.jpg', name: 'Jolio Mark', role: 'Designer' },
    { id: 2, src: '9.jpg', name: 'Thomas A. Deloach', role: 'UX Designer' },
    { id: 3, src: '4.jpg', name: 'John E. Cammack', role: 'Designer' },
    { id: 4, src: '12.png', name: 'Daniele G. Ferguson', role: 'Designer' },
    { id: 5, src: '14.png', name: 'Nathan C. Wilson', role: 'Painter' },
];

export const singleBlogContent = [
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like"
]

//Add Post
export const dataTypeahead = [{ name: 'Lifestyle' }, { name: 'Travel' }, { name: 'Food' }, { name: 'Beauty' },];

export const postEditRadios = [
    { id: 1, text: 'Text' },
    { id: 2, text: 'Image' },
    { id: 3, text: 'Audio', check: 'checked' },
    { id: 4, text: 'Video' },
];
